import { ContentRenderer } from '@peakconcepts/landingpage-kit'
import content from './content'
import './index.css'

function App() {
  return (
    <div className="App">
      <ContentRenderer content={content} />
    </div>
  )
}

export default App
